import { TimeSeriesDataModule, } from '@iot-app-kit/core';
import { getIotEventsClient, getSiteWiseClient } from '@iot-app-kit/core-util';
import { SiteWiseTimeSeriesDataProvider } from './time-series-data/provider';
import { SiteWiseAssetModule, SiteWiseAssetTreeSession, } from './asset-modules';
import { SiteWiseComponentSession } from './component-session';
import { createSiteWiseAssetDataSource } from './asset-modules/asset-data-source';
import { createDataSource } from './time-series-data';
import { assetSession } from './sessions';
import { SiteWiseAlarmModule } from './alarms/iotevents';
import { fetchTimeSeriesData } from './time-series-data/fetchTimeSeriesData';
const SOURCE = 'iotsitewise';
/**
 * Initialize IoT App Kit
 *
 * @param awsCredentials - https://www.npmjs.com/package/@aws-sdk/credential-providers
 * @param awsRegion - Region for AWS based data sources to point towards, i.e. us-east-1
 */
export const initialize = (input) => {
    const siteWiseClient = getSiteWiseClient(input);
    const iotEventsClient = getIotEventsClient(input);
    const assetDataSource = createSiteWiseAssetDataSource(siteWiseClient);
    const siteWiseAssetModule = new SiteWiseAssetModule(assetDataSource);
    const siteWiseTimeSeriesModule = new TimeSeriesDataModule(createDataSource(siteWiseClient, input.settings));
    const siteWiseAlarmModule = new SiteWiseAlarmModule(iotEventsClient, siteWiseAssetModule);
    return {
        query: {
            fetchTimeSeriesData: fetchTimeSeriesData(siteWiseTimeSeriesModule),
            timeSeriesData: (query) => ({
                toQueryString: () => JSON.stringify({
                    source: SOURCE,
                    queryType: 'time-series-data',
                    query,
                }),
                build: (sessionId, params) => new SiteWiseTimeSeriesDataProvider(new SiteWiseComponentSession({
                    componentId: sessionId,
                    siteWiseTimeSeriesModule,
                    siteWiseAssetModule,
                    siteWiseAlarmModule,
                }), {
                    queries: [query],
                    request: params,
                }),
            }),
            assetTree: {
                fromRoot: (args = {}) => ({
                    toQueryString: () => JSON.stringify({
                        source: SOURCE,
                        queryType: 'assets-from-root',
                        query: args,
                    }),
                    build: (sessionId) => {
                        const session = new SiteWiseComponentSession({
                            componentId: sessionId,
                            siteWiseTimeSeriesModule,
                            siteWiseAssetModule,
                            siteWiseAlarmModule,
                        });
                        return new SiteWiseAssetTreeSession(assetSession(session), args);
                    },
                }),
                fromAsset: (args) => {
                    return {
                        toQueryString: () => JSON.stringify({
                            source: SOURCE,
                            queryType: 'assets-from-asset',
                            query: args,
                        }),
                        build: (sessionId) => {
                            const session = new SiteWiseComponentSession({
                                componentId: sessionId,
                                siteWiseTimeSeriesModule,
                                siteWiseAssetModule,
                                siteWiseAlarmModule,
                            });
                            return new SiteWiseAssetTreeSession(assetSession(session), args);
                        },
                    };
                },
            },
        },
    };
};
